<template>
  <div class="applicant-duplicate-entries">
    <el-dialog custom-class="with-title large" :title="title" :visible.sync="visible" :before-close="beforeClose">
      <div class="applicant-duplicate-entries-post pt-x1 pb-x1" v-for="(post, index) in posts" style="width: 100%">
        <div class="applicant-duplicate-entries-row" layout="row" layout-align="space-between-center">
          <span class="text-sub-color">{{ formatDatetime(post.publishDatetime) }}</span
          ><a class="link-to-post" v-if="post.postType !== 'comment'" :href="post.permalink" target="_new"
            ><i class="mdi mdi-open-in-new"></i
          ></a>
        </div>
        <div
          class="applicant-duplicate-entries-row"
          layout="row"
          layout-align="space-between-center"
          v-if="post.postType !== 'comment' && post.mediaUrl"
        >
          <img class="instagram-media mt-x1" :src="post.mediaUrl" style="width: 100%" />
        </div>
        <div class="applicant-duplicate-entries-row" layout="row" layout-align="space-between-center">
          {{ post.message }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.applicant-duplicate-entries-post:nth-child(n) {
  border-top: 1px solid $border-color;
}

.applicant-duplicate-entries-post:first-child {
  border-top: none !important;
}

.applicant-duplicate-entries-post:last-child {
  border-bottom: 1px solid $border-color;
}

.link-to-post {
  color: black;
}

.link-to-post:hover {
  text-decoration: none;
}

.applicant-duplicate-entries-row {
  padding-right: $spacing-unit;
  padding-left: $spacing-unit;
}
</style>
<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { defineComponent } from 'vue'

import { formatDatetime } from '@/client/filters/filters'

export default defineComponent({
  data() {
    return {
      title: '',
      visible: false,
      posts: Array
    }
  },
  methods: {
    formatDatetime,

    /**
     * ダイアログを開く
     * @param {string} accountName account name
     * @param {any} posts list post
     */
    open(accountName: string, posts: any) {
      this.visible = true
      this.posts = posts
      this.title = `${accountName} さんの重複応募詳細(${this.posts ? this.posts.length : 0}件)`
    },

    /**
     * ダイアログ閉じるイベント
     * @param {any} done done event
     */
    beforeClose(done: any) {
      this.title = ''
      done()
    }
  }
})
</script>
